import moment from 'moment';
import React from 'react';

import {Icon, Text, WithTooltip} from '@albert-io/atomic';
import {POINTS_EARNED_TOOLTIP} from 'client/TeacherDashboard/config/copy';
import {humanReadableDurationString} from 'lib/timeUtils';

import type {OverviewTiles} from './useClassOverview';

interface TileProps {
  value: React.ReactNode;
  label: string;
  tooltip?: React.ReactNode;
}

const Tile = ({value, label, tooltip}: TileProps) => (
  <div className='flex flex-col items-center gap-x0-half text-center'>
    <Text size='xl' bold color='tertiary'>
      {value}
    </Text>
    <div className='flex items-center gap-x0-half'>
      <Text size='s' color='tertiary'>
        {label}
      </Text>
      {tooltip}
    </div>
  </div>
);

interface Props {
  tiles: OverviewTiles;
}

export const StatTiles = ({tiles}: Props) => (
  <div className='grid grid-cols-1 gap-x3 gap-y-x4 xs:grid-cols-3'>
    <Tile value={tiles.activeStudents} label='active students' />
    <Tile value={tiles.inactiveStudents} label='inactive students' />
    <Tile value={tiles.questionsAnswered} label='questions answered' />
    <Tile
      value={tiles.pointsEarned}
      label='points earned'
      tooltip={
        <WithTooltip content={POINTS_EARNED_TOOLTIP} theme='light' focusable>
          <Icon icon='info-circle' iconStyle='regular' color='secondary' />
        </WithTooltip>
      }
    />
    <Tile value={`${tiles.averageAccuracy}%`} label='average accuracy' />
    <Tile
      value={humanReadableDurationString(moment.duration(tiles.timeSpentMs, 'milliseconds'))}
      label='time spent'
    />
  </div>
);
